
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meet-your-new-team",
      function () {
        return require("private-next-pages/meet-your-new-team.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meet-your-new-team"])
      });
    }
  